<template>
  <div>
    <yi_curd_table v-show="false" v-bind="$attrs" :name="$options.name" ref="yt"> </yi_curd_table>
    <el-table class="currentTable" size="mini" :data="sub" :header-cell-style="{ color: '#606266', 'font-weight': '700', height: '48px', padding: '0px', 'font-size': '14px' }">
      <el-table-column v-for="(item, index) in subItemList.tableColumn" :key="index" :prop="item.prop" :label="$t(item.label)" :width="item.width" :show-overflow-tooltip="true"> </el-table-column>
      <el-table-column fixed :label="$t('caozuo')" width="260">
        <template slot-scope="scope">
          <el-tag v-if="utils.checkPower('web_production_management_wo_report')&&(status == 3 || status == 4 || status == 5)" effect="plain" @click="baogong(scope.row, 'button1')">
            {{ $t('baogong') }}
          </el-tag>
          <el-tag v-if="utils.checkPower('web_production_management_wo_bad_entry')&&(status == 3 || status == 4 || status == 5)" style="margin-left: 5px;" effect="plain" @click="buliangluru(scope.row)">
            {{ $t('buliangluru') }}
          </el-tag>
          <el-tag v-if="utils.checkPower('web_production_management_wo_quality_doc')" style="margin-left: 5px;margin-bottom: 5px" effect="plain" @click="getTask(scope.row)">
            {{ $t('zuoyezhidaoshu') }}
          </el-tag>
          <el-tag v-if="(status == 3 || status == 4 || status == 5) && utils.checkPower('button_group_leader_report')" effect="plain" @click="baogong(scope.row, 'button2')">
            {{ $t('zuzhangbaogong') }}
          </el-tag>
          <el-tag v-if="utils.checkPower('web_production_management_wo_unqualified_report')" effect="plain" @click="buliangbaogong(scope.row, 'button2')">
            {{ $t('buliangbaogong') }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!--报工列表-->
      <template v-if="yt.editObj.action == 'baogong'">
        <div class="dialog-scroller">
          <div>
            <div style="width: 280px; float: right">
              <div style="flex: 1;overflow: auto;">
                <div id="buliang_flow" :style="{ height: flow2Height + 'px', width: flow1Width + 'px' }"></div>
              </div>
            </div>
            <el-tabs v-model="topActive" @tab-click="handleClick" style="width: 60%">
              <el-tab-pane v-for="(top, index) in tab" :key="top.material.name" :label="top.material.name" :name="top.material.name">
                <div style="display: flex;flex-wrap: nowrap;">
                  <div class="inputNum">
                    <el-form :model="conditions" ref="form" size="mini" :label-width="yt.formLabelWidth">
                      <el-form-item class="noborder" :label="$t('gongxubianma/miaoshu')">
                        <el-input disabled v-model="top.procedureName"></el-input>
                      </el-form-item>
                      <el-form-item class="noborder" :label="$t('shebeimingcheng')">
                        <yi_cross_select disabled multiple :component="'web_base_equipment_list'" :ids.sync="top.equipmentId"> </yi_cross_select>
                      </el-form-item>
                      <el-form-item :label="$t('baogongriqi')" required>
                        <yi_time_input :format="'yyyy-MM-dd'" type="date" :time.sync="conditions.reportDate"> </yi_time_input>
                      </el-form-item>
                      <el-form-item :label="$t('baogongbanci')" required>
                        <el-select filterable :clearable="true" v-model="yt.editObj.shiftId" @change="changeValue">
                          <el-option v-for="(item, index) in ShiftByEquipmentList" :key="index" :label="item.name" :value="item.id"> </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')">
                        <yi_cross_select disabled :selectTitle="'code,name'" multiple :component="'web_base_matter_list'" :ids.sync="top.materialId"> </yi_cross_select>
                      </el-form-item>
                      <el-form-item class="noborder" :label="$t('jihuashuliang')">
                        <el-input disabled type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="top.planQuantity" size="mini"> </el-input>
                        <!--                        <el-input-number disabled :precision="0" :min="0" :step="1" :controls="false" size="mini" v-model="top.planQuantity" >-->
                        <!--                        </el-input-number>-->
                      </el-form-item>
                      <el-form-item class="noborder" :label="$t('shengyushengchanshuliang')">
                        <el-input disabled type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="leftQuantity" size="mini"> </el-input>
                      </el-form-item>
                      <el-form-item :label="$t('dangbanbaogongshuliang')" required>
                        <!--                        <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')"-->
                        <!--                            v-model="shiftReportQuantity" size="mini">-->
                        <!--                        </el-input>-->
                        <el-input-number :precision="0" :min="0" :step="1" :controls="false" size="mini" v-model="shiftReportQuantity"> </el-input-number>
                      </el-form-item>
                      <el-form-item :label="$t('dangbanbuliangshuliang')" required>
                        <el-input-number :precision="0" :min="0" :step="1" :controls="false" size="mini" v-model="shiftBadQuantity"> </el-input-number>
                        <!--                        <el-input type="number" oninput="value=value.replace(/^0+(\d)|[^\d]+/g,'')"-->
                        <!--                            v-model="shiftBadQuantity" size="mini">-->
                        <!--                        </el-input>-->
                      </el-form-item>
                      <el-form-item v-if="showContent" :label="$t('caozuoren')" required>
                        <!--                        <yi_cross_select :max="1" :component="'web_system_user_list'"-->
                        <!--                            :ids.sync="yt.editObj.reporter">-->
                        <!--                        </yi_cross_select>-->
                        <yi_data_select :max="1" :type="'customer_user'" :ids.sync="yt.editObj.reporter"> </yi_data_select>
                      </el-form-item>
                      <el-form-item :label="$t('beizhu')">
                        <el-input type="textarea" v-model="remarks" maxlength="400"> </el-input>
                      </el-form-item>
                    </el-form>
                  </div>
                  <!--                  <div style="flex: 1;overflow: auto;">-->
                  <!--                    <div id="buliang_flow" :style="{height:flow2Height+'px'}">-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="reportWork" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'buliangluru'">
        <div class="dialog-scroller">
          <el-tabs v-model="topActive2" type="card" closable @tab-click="handleClick1">
            <el-tab-pane v-for="(topTab, index) in tab" :key="topTab.material.name" :label="topTab.material.name" :name="topTab.material.name"> </el-tab-pane>

            <div class="wrap">
              <el-tabs v-model="topActive1" @tab-click="handleClick2" style="width: 60%">
                <div style="display: flex;flex-wrap: nowrap;margin-bottom: 20px">
                  <div>{{ $t('bencibulubuliangpinshu') }}：{{ accumulate }}</div>
                  <div style="margin-left: 20px">{{ $t('gongxubianma/miaoshu') }}：{{ procedureName }}</div>
                </div>
                <div></div>
                <el-tab-pane class="left" v-for="(top1, index) in tabs" :label="top1.name" :name="top1.name">
                  <div v-for="(item, i) in top1.defectCodeVOS" style="width:45%;">
                    <div style="display: flex;align-items:center;justify-content: space-between;margin-bottom:10px;margin-right: 20px;">
                      <div style="flex: 1;text-align: right;padding-right: 8px;">{{ item.desc }}</div>
                      <div class="badText" style="display: flex;flex-wrap: nowrap;flex-direction: row;justify-content: center;align-items: center;">
                        <el-button size="mini" type="info" plain @click="reduce(index, i)" :disabled="item.badQuantityTmp <= 0">-</el-button>
                        <el-input-number :precision="0" :min="0" :step="1" :controls="false" size="mini" v-model="item.badQuantityTmp"></el-input-number>
                        <el-button size="mini" type="info" plain @click="plus(index, i)" style="margin-left: -10px">+</el-button>
                      </div>
                    </div>
                    <div></div>
                  </div>
                </el-tab-pane>
              </el-tabs>
              <div class="right" style="width: 280px;">
                <div style="flex: 1;overflow: auto;">
                  <div id="buliang_flow" :style="{ height: flow2Height + 'px', width: flow1Width + 'px' }"></div>
                </div>
              </div>
            </div>
          </el-tabs>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/wo/bad/quantity/record/entry', beforeAdd, afterReq)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action === 'zuoyezhidaoshu'">
        <div class="dialog-scroller">
          <el-table :data="fileList" border style="width: 100%">
            <el-table-column prop="fileInfo.name" :label="$t('wenjianmingcheng')" width="180"></el-table-column>
            <el-table-column prop="createByObject.nickname" :label="$t('chuangjianren')" width="180"></el-table-column>
            <el-table-column prop="createTime" :label="$t('chuangjianshijian')">
              <template slot-scope="scope">
                {{ scope.row.createTime != null ? dayjs.unix(scope.row.createTime / 1000).format('YYYY-MM-DD HH:mm:ss') : '' }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('caozuo')">
              <template slot-scope="scope">
                <el-button type="text" @click="setFileId(scope.row)">{{ $t('yulan') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: right">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 100, 500]" :page-size="10" layout="sizes, prev, pager, next" :total="total"> </el-pagination>
          </div>
        </div>
      </template>
      <template v-if="yt.editObj.action == 'buliangbaogong'">
        <div class="dialog-scroller">
          <el-tabs v-model="topActive2" type="card" closable @tab-click="handleClick1">
            <el-tab-pane v-for="(topTab, index) in tab" :key="topTab.material.name" :label="topTab.material.name" :name="topTab.material.name"> </el-tab-pane>

            <div class="wrap">
              <el-tabs v-model="topActive1" @tab-click="handleClick2" style="width: 60%">
                <div style="display: flex;flex-wrap: nowrap;margin-bottom: 20px">
                  <div>{{ $t('bencibulubuliangpinshu') }}：{{ accumulate }}</div>
                  <div style="margin-left: 20px">{{ $t('gongxubianma/miaoshu') }}：{{ procedureName }}</div>
                </div>
                <div></div>
                <el-tab-pane class="left" v-for="(top1, index) in tabs" :label="top1.name" :name="top1.name">
                  <div v-for="(item, i) in top1.defectCodeVOS" style="width:45%;">
                    <div style="display: flex;align-items:center;justify-content: space-between;margin-bottom:10px;margin-right: 20px;">
                      <div style="flex: 1;text-align: right;padding-right: 8px;">{{ item.desc }}</div>
                      <div class="badText" style="display: flex;flex-wrap: nowrap;flex-direction: row;justify-content: center;align-items: center;">
                        <el-button size="mini" type="info" plain @click="reduce(index, i)" :disabled="item.badQuantityTmp <= 0">-</el-button>
                        <el-input-number :precision="0" :min="0" :step="1" :controls="false" size="mini" v-model="item.badQuantityTmp"></el-input-number>
                        <el-button size="mini" type="info" plain @click="plus(index, i)" style="margin-left: -10px">+</el-button>
                      </div>
                    </div>
                    <div></div>
                  </div>
                </el-tab-pane>
              </el-tabs>
              <div class="right" style="width: 280px;">
                <div style="flex: 1;overflow: auto;">
                  <div id="buliang_flow" :style="{ height: flow2Height + 'px', width: flow1Width + 'px' }"></div>
                </div>
              </div>
            </div>
          </el-tabs>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/custom/weier/wo/unqualifiedReport', beforeUnqualifiedReport, afterReq)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
    
    <!-- 文件预览对话框 -->
    <el-dialog
      :title="previewFileInfo ? previewFileInfo.fileInfo.name : '文件预览'"
      :visible.sync="previewDialogVisible"
      width="90%"
      :close-on-click-modal="false"
      append-to-body
      @close="closePreview">
      <div class="preview-container" style="height: 70vh; overflow: auto;">
        <!-- 图片预览 -->
        <div v-if="previewFileType === 'image'" style="text-align: center;">
          <img :src="previewFileUrl" style="max-width: 100%; max-height: 100%;" alt="图片预览" />
        </div>
        
        <!-- PDF预览 -->
        <div v-else-if="previewFileType === 'pdf'" style="height: 100%;">
          <iframe :src="previewFileUrl" style="width: 100%; height: 100%; border: none;"></iframe>
        </div>
        
        <!-- Word文档预览 -->
        <div v-else-if="previewFileType === 'word'" style="height: 100%;">
          <iframe :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(previewFileUrl)" 
                  style="width: 100%; height: 100%; border: none;"></iframe>
        </div>
        
        <!-- Excel预览 -->
        <div v-else-if="previewFileType === 'excel'" style="height: 100%;">
          <iframe :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(previewFileUrl)" 
                  style="width: 100%; height: 100%; border: none;"></iframe>
        </div>
        
        <!-- 视频预览 -->
        <div v-else-if="previewFileType === 'video'" style="text-align: center;">
          <video :src="previewFileUrl" controls style="max-width: 100%; max-height: 100%;">
            您的浏览器不支持视频播放
          </video>
        </div>
        
        <!-- 不支持预览的文件类型:该文件类型不支持在线预览 -->
        <div v-else style="text-align: center; padding: 50px;">
          <i class="el-icon-document" style="font-size: 64px; color: #ccc;"></i>
          <p style="margin-top: 20px; color: #999;">{{ $t('gaiwenjianbuzhichizaixianyulan') }}</p>
          <el-button type="primary" @click="downloadFile">{{ $t('log_files_download') }}</el-button>
        </div>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="closePreview">{{ $t('guanbi') }}</el-button>
        <el-button type="primary" @click="downloadFile">{{ $t('xiazai') }}</el-button>
      </span>
    </el-dialog>
    
    <div></div>
  </div>
</template>

<script type="text/javascript">
export default {
  props: ['sub', 'status', 'equipmentId', 'all'],
  name: 'web_mold_management_maintenance_execution_item',
  data() {
    return {
      fileList: [],
      editObject: {},
      page: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      params: {},
      paramsList: {},
      count: 0,
      showContent: false,
      result: '', //校验结果
      routeWorkProcedureId: null,
      conditions: {},
      obj: {},
      ShiftByEquipmentList: [], //班次数据
      shiftIdListId: null,
      // key: 0,
      remarks: '',
      shiftReportQuantity: null,
      tab: [],
      tabs: [],
      fildIds: '',
      parentIds: '',
      curShiftQuantity: '', //当班报工数
      shiftBadQuantity: '', //当班不良数
      leftQuantity: '', //剩余生产数量
      defectCodeName: [],
      topActive: '',
      topActive1: '',
      topActive2: '',
      parentIdItem: '',
      flow2Height: 10,
      flow1Width: 10,
      activeName: 'first',
      editConditions: {
        priority: ''
      },
      drawer: false,
      direction: 'btt',
      addDrawer: false,
      updateDrawer: false,
      graph: null,
      currentNode: null,
      currentNodeId: null,
      selectParentIds: null,
      priority: null,
      routeList: [],
      nodeList: [],
      flows: [],
      currentNodeIds: null,
      procedureName: null,
      equipmentList: [],
      subList: [],
      selected: null,
      workProcedureIds: null,
      sign: '',
      shiftStartTime: '',
      // 新增预览相关数据
      previewDialogVisible: false,
      previewFileInfo: null,
      previewFileUrl: '',
      previewFileType: '',
      subItemList: {
        tableColumn: [
          {
            label: 'gongxugongdanhao',
            prop: 'no',
            width: 150
          },
          {
            label: 'gongxubianma',
            prop: 'procedureCode',
            width: 100
          },
          {
            label: 'gongxumiaoshu',
            prop: 'procedureDesc',
            width: 100
          },
          {
            label: 'jihuashuliang',
            prop: 'planQuantity',
            width: 100
          },
          {
            label: 'baogongshuliang',
            prop: 'reportQuantity',
            width: 100
          },
          {
            label: 'yibaogongliangpinshu',
            prop: 'finishGoodQuantity',
            width: 130
          },
          {
            label: 'yibaogongbuliangpinshu',
            prop: 'finishBadQuantity',
            width: 130
          },
          {
            label: 'shengyushengchanshuliang',
            prop: 'leftProductionQuantity'
            // width: 100
          }
        ],
        tableData: [],
        allCount: []
      }
    };
  },
  created() {
    // this.$set(this.conditions, 'reportDate', this.begin());
    this.utils.event_hub.$on('node2Tap', this.node2Tap);
  },
  computed: {
    accumulate() {
      console.log(1111);
      let total = 0;
      for (let i = 0; i < this.tabs.length; i++) {
        let all = this.tabs[i]['defectCodeVOS'];
        for (let j = 0; j < all.length; j++) {
          if (all[j].badQuantityTmp != null) {
            total += all[j].badQuantityTmp;
          }
        }
      }
      return total;
    }
  },
  watch: {
    workProcedureIds: {
      handler(n, o) {
        console.log(111);
        if (o != null && n != o) {
          this.getDefectTab({
            workProcedureId: n
          });
        }
      },
      immediate: false,
      deep: true
    },
    currentNodeIds: {
      handler(n, o) {
        console.log(222);

        // console.log('n', n)
        // console.log('o', o)
        // console.log('currentNodeIds',n)
        if (n) {
          this.getInfo();
        }
      },
      immediate: false,
      deep: true
    },
    'yt.isShowEditDialog': {
      handler(n, o) {
        console.log(333);

        if (n == false && this.yt.editObj.action == 'baogong') {
          this.utils.event_hub.$emit('WEB_WORK_ORDER_EXECUTION_REFRESH');
        }
        if (n == true && this.yt.editObj.action == 'baogong') {
          this.fetchChart();
        }
        if (n == true && (this.yt.editObj.action == 'buliangluru'||this.yt.editObj.action == 'buliangbaogong')) {
          this.fetchChart();
        }
      },
      immediate: false,
      deep: true
    }
  },
  mounted() {
    this.subItemList.tableData = this.sub;
  },
  methods: {
    reduce(index, i) {
      let tmp = parseInt(this.tabs[index]['defectCodeVOS'].badQuantityTmp);
      this.tabs[index]['defectCodeVOS'][i].badQuantityTmp--;
      // console.log(this.tabs[index]['defectCodeVOS'][i].badQuantityTmp)
    },
    plus(index, i) {
      let tmp = parseInt(this.tabs[index]['defectCodeVOS'].badQuantityTmp);
      this.tabs[index]['defectCodeVOS'][i].badQuantityTmp++;
      // console.log(this.tabs[index]['defectCodeVOS'][i].badQuantityTmp)
    },
    changeValue(value) {
      this.$forceUpdate();
      if (Array.isArray(this.ShiftByEquipmentList) && this.ShiftByEquipmentList.length > 0) {
        this.obj = this.ShiftByEquipmentList.find(item => {
          return item.id === value;
        });
      }
    },
    baogong(row, button) {
      console.log('buttton', button);
      this.currentItem = {
        item: row
      };
      if (button === 'button2') {
        this.showContent = true;
      } else {
        this.showContent = false;
      }
      this.procedureId = row.id;
      this.yt.showEditDialog('baogong', row, 'w2');
      this.$nextTick(async () => {
        await this.getTab();
        await this.getEquipmentId();
        setTimeout(() => {
          this.getShiftByEquipmentId();
        }, 500);

        await this.fetchChart();
        setTimeout(() => {
          this.handleSetDefBaoGongTab(row.id);
          this.fetchChart();
        }, 1000);
      });
    },
    buliangluru(row) {
      this.currentItem = {
        item: row
      };
      this.procedureId = row.id;
      this.yt.showEditDialog('buliangluru', row, 'w2');
      this.$nextTick(async () => {
        await this.getTab();
        await this.handleSetDefBaoGongTab(row.id);
        await this.getDefectTab(row);
        await this.fetchChart();
        setTimeout(() => {
          this.handleSetDefBaoGongTab(row.id);
          this.fetchChart();
        }, 1000);
      });
    },
    buliangbaogong(row) {
      this.currentItem = {
        item: row
      };
      this.procedureId = row.id;
      this.yt.showEditDialog('buliangbaogong', row, 'w2');
      this.$nextTick(async () => {
        await this.getTab();
        await this.handleSetDefBaoGongTab(row.id);
        await this.getDefectTab(row);
        await this.fetchChart();
        await this.getEquipmentId();
        setTimeout(() => {
          this.yt.editObj.shiftId = this.shiftIdListId.id;
          this.handleSetDefBaoGongTab(row.id);
          this.fetchChart();
        }, 1000);
      });
    },
    handleSizeChange(val) {
      console.log(this.editObject);
      this.page.pageSize = val;
      this.getTask(this.editObject);
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(this.yt.editObj.action);
      this.page.pageNum = val;
      this.getTask(this.editObject);
      console.log(`当前页: ${val}`);
    },
    setFileId(row) {
      console.log('row:', row);
      if (row.fileInfoId) {
        this.fildIds = row.fileInfoId;
        this.previewFile(row);
      }
    },
    //作业指导书
    getTask(editObj) {
      this.editObject = editObj;
      return this.http
        .get('/web/production/wo/quality/doc?woProcedureId=' + editObj.id + '&pageNum=' + this.page.pageNum + '&pageSize=' + this.page.pageSize)
        .then(res => {
          if (res.data.total == 1) {
            this.fildIds = res.data.rows[0].fileInfoId;
            this.previewFile(res.data.rows[0]);
          }
          if (res.data.total > 1) {
            this.fileList = res.data.rows;
            this.total = res.data.total;
            this.page.pageSize = 10;
            this.page.pageNum = 1;
            this.yt.showEditDialog('zuoyezhidaoshu', null, '800px');
          }
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    //作业指导书下载
    getDownload() {
      return this.http.get('/web/customer/files/download?id=' + this.fildIds).then(res => {
        let baseUrl = res.data;
        if (res.data) {
          window.open(baseUrl);
        }
      });
    },
    //文件预览
    previewFile(fileRow) {
      this.previewFileInfo = fileRow;
      // 获取文件下载URL
      return this.http.get('/web/customer/files/download?id=' + fileRow.fileInfoId).then(res => {
        if (res.data) {
          this.previewFileUrl = res.data;
          // 根据文件扩展名判断文件类型
          const fileName = fileRow.fileInfo ? fileRow.fileInfo.name : '';
          this.previewFileType = this.getFileType(fileName);
          this.previewDialogVisible = true;
        }
      }).catch(error => {
        this.$message.error('获取文件预览地址失败');
      });
    },
    //获取文件类型
    getFileType(fileName) {
      if (!fileName) return 'unknown';
      const ext = fileName.toLowerCase().split('.').pop();
      const typeMap = {
        // 图片格式
        'png': 'image',
        'jpg': 'image',
        'jpeg': 'image',
        'gif': 'image',
        'bmp': 'image',
        'webp': 'image',
        // PDF格式
        'pdf': 'pdf',
        // Word文档格式
        'doc': 'word',
        'docx': 'word',
        // Excel格式
        'xls': 'excel',
        'xlsx': 'excel',
        // 视频格式
        'mp4': 'video',
        'avi': 'video',
        'mpeg': 'video',
        'mov': 'video',
        'wmv': 'video',
        'flv': 'video'
      };
      return typeMap[ext] || 'unknown';
    },
    //关闭预览对话框
    closePreview() {
      this.previewDialogVisible = false;
      this.previewFileInfo = null;
      this.previewFileUrl = '';
      this.previewFileType = '';
    },
    //下载文件
    downloadFile() {
      if (this.previewFileUrl) {
        window.open(this.previewFileUrl);
      }
    },
    //获取当班报工数量、当班不良数量、剩余生产数量
    getInfo() {
      return this.http
        .get('/web/production/wo/procedure/info?woProcedureId=' + this.currentNodeIds)
        .then(res => {
          this.shiftReportQuantity = res.data.shiftReportQuantity;
          this.shiftBadQuantity = res.data.shiftBadQuantity;
          this.leftQuantity = res.data.leftQuantity;
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    begin() {
      const date = new Date();
      const begin = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()).getTime();
      return begin;
    },
    afterReq() {
      //不良补录通知父级刷新
      this.yt.isShowEditDialog = false;
      this.utils.event_hub.$emit('WEB_WORK_ORDER_EXECUTION_REFRESH');
    },
    getTab() {
      let params = {
        procedureId: this.procedureId
      };
      this.http
        .get('/web/production/wo/report/tab', {
          params
        })
        .then(res => {
          this.tab = res.data || [];
          let material = this.tab.map(item => {
            return item.material;
          });
          if (!material.length == '') {
            this.topActive = material[0]['name'];
            this.topActive2 = material[0]['name'];
          }
          if (this.topActive) {
            this.fetchChart();
          }
          setTimeout(() => {
            if (this.topActive1 && this.topActive2) {
              this.fetchChart();
            }
          }, 1000);
        });
    },
    getDefectTab(row) {
      this.http
        .get('/web/basic/defectType/getDefectTypeAndCode', {
          params: {
            level: 1,
            workProcedureId: row.workProcedureId
          }
        })
        .then(res => {
          this.tabs = res.data || [];
          this.tabs.forEach((val, index, val_arr) => {
            if (val_arr[index].defectCodeVOS.length != 0 && val_arr[index].defectCodeVOS != []) {
              val_arr[index].defectCodeVOS.forEach((el, i, el_arr) => {
                this.defectCodeName = el_arr;
              });
            }
          });
          for (let i = 0; i < this.tabs.length; i++) {
            for (let j = 0; j < this.tabs[i]['defectCodeVOS'].length; j++) {
              if (this.tabs[i]['defectCodeVOS'][j].badQuantity == null) {
                this.$set(this.tabs[i]['defectCodeVOS'][j], 'badQuantityTmp', 0);
              }
            }
          }
          if (!this.tabs.length == '') {
            this.topActive1 = this.tabs[0]['name'];
          }
        });
    },
    fetchChart() {
      if (this.yt.editObj.action == 'buliangluru'||this.yt.editObj.action == 'buliangbaogong') {
        const currentTab = this.tab.find(item => {
          return item.material.name === this.topActive2;
        });

        if (currentTab) {
          const res = {
            data: currentTab.woProcedureList
          };
          if (this.sign) {
            this.currentItem = { item: currentTab.woProcedureList[0] };
          }

          let nodes = res.data.map(item => {
            return {
              id: item.routeWorkProcedureId + '',
              shape: 'node2',
              width: 110,
              height: 40,
              data: {
                priority: item.priority,
                item: JSON.parse(JSON.stringify(item))
              }
            };
          });
          let edges = [];
          for (var i = 0; i < res.data.length; i++) {
            let node = res.data[i];
            if (res.data[i].parentIds == '') {
              continue;
            }
            let parentIdArr = res.data[i].parentIds.split(',');
            for (var j = 0; j < parentIdArr.length; j++) {
              edges.push({
                source: parentIdArr[j],
                target: node.routeWorkProcedureId + '',
                router: {
                  name: 'manhattan',
                  startDirections: ['right'],
                  endDirections: ['left']
                }
              });
            }
          }
          setTimeout(() => {
            this.initFlow('buliang_flow', nodes, edges);
          }, 500);
        }
      }
      if (this.yt.editObj.action == 'baogong') {
        const currentTab = this.tab.find(item => {
          return item.material.name === this.topActive;
        });
        console.log('currentTab111', this.topActive);
        if (currentTab) {
          const res = {
            data: currentTab.woProcedureList
          };
          if (this.sign) {
            this.currentItem = { item: currentTab.woProcedureList[0] };
          }
          let nodes = res.data.map(item => {
            return {
              id: item.routeWorkProcedureId + '',
              shape: 'node2',
              width: 110,
              height: 40,
              data: {
                priority: item.priority,
                item: JSON.parse(JSON.stringify(item))
              }
            };
          });
          let edges = [];
          for (var i = 0; i < res.data.length; i++) {
            let node = res.data[i];
            if (res.data[i].parentIds == '') {
              continue;
            }
            let parentIdArr = res.data[i].parentIds.split(',');
            for (var j = 0; j < parentIdArr.length; j++) {
              edges.push({
                source: parentIdArr[j],
                target: node.routeWorkProcedureId + '',
                router: {
                  name: 'manhattan',
                  startDirections: ['right'],
                  endDirections: ['left']
                }
              });
            }
          }
          setTimeout(() => {
            this.initFlow('buliang_flow', nodes, edges);
          }, 500);
        }
        this.handleSetDefBaoGongTab();
      }
    },
    handleClick(tab, event) {
      this.sign = tab;
      console.log('aaaaaa', tab);
      if (tab.name) {
        this.fetchChart();
        // this.handleSetBaoGongLabel()
      }
      this.remarks = '';
    },
    handleClick1(tab, event) {},
    handleClick2(tab, event) {},
    reportWork() {
      if (this.showContent === true) {
        this.params = {
          shiftId: this.yt.editObj.shiftId,
          curShiftQuantity: this.shiftReportQuantity,
          woProcedureId: this.currentNodeIds,
          curShiftBadQuantity: this.shiftBadQuantity,
          reportDate: this.conditions.reportDate,
          remark: this.remarks,
          reporter: this.yt.editObj.reporter
        };
        this.http
          .post('/web/production/wo/reportValidByGroupLeader', this.params)
          .then(res => {
            this.result = res.data.code;

            if (this.result == 0) {
              this.getReport();
              this.getInfo();
              // this.getTab()
              // this.defaultSratus= true
              // this.currentItem = this.topActive1
              // this.yt.editObj.shiftId=[]
            }
            if (this.result == 1) {
              let value = res.data.value;
              this.$message.error(this.$t('报工间隔限制' + value + this.$t('小时，请稍后再报工')));
            }
            if (this.result == 2) {
              let value = res.data.value;
              this.$confirm('上次报工时间是' + this.dateFormat(value) + '是否确认提交报工?', this.$t('baogongqueren'), {
                confirmButtonText: this.$t('queding'),
                cancelButtonText: this.$t('quxiao'),
                type: 'warning'
              })
                .then(() => {
                  this.getReport();
                  this.getInfo();
                  this.getTab();
                  // this.yt.editObj.shiftId=[]
                  this.fetchChart();
                })
                .catch(() => {});
            }
            // console.log('111wwddd',this.result)
          })
          .catch(error => {
            this.$message.error(this.$t(error));
          });
      } else {
        this.params = {
          shiftId: this.yt.editObj.shiftId,
          curShiftQuantity: this.shiftReportQuantity,
          woProcedureId: this.currentNodeIds,
          curShiftBadQuantity: this.shiftBadQuantity,
          reportDate: this.conditions.reportDate,
          remark: this.remarks
        };
        this.http
          .post('/web/production/wo/reportValid', this.params)
          .then(res => {
            this.result = res.data.code;

            if (this.result == 0) {
              this.getReport();
              this.getInfo();
              // this.getTab()
              // this.yt.editObj.shiftId=[]
            }
            if (this.result == 1) {
              let value = res.data.value;
              this.$message.error(this.$t('报工间隔限制' + value + this.$t('小时，请稍后再报工')));
            }
            if (this.result == 2) {
              let value = res.data.value;
              this.$confirm('上次报工时间是' + this.dateFormat(value) + '是否确认提交报工?', this.$t('baogongqueren'), {
                confirmButtonText: this.$t('queding'),
                cancelButtonText: this.$t('quxiao'),
                type: 'warning'
              })
                .then(() => {
                  this.getReport();
                  this.getInfo();
                  // this.getTab()
                  // this.yt.editObj.shiftId=[]
                  this.fetchChart();
                })
                .catch(() => {});
            }
            // console.log('111wwddd',this.result)
          })
          .catch(error => {
            this.$message.error(this.$t(error));
          });
      }
    },
    getReport() {
      if (this.showContent === true) {
        this.paramsList = {
          shiftId: this.yt.editObj.shiftId,
          curShiftQuantity: this.shiftReportQuantity,
          woProcedureId: this.currentNodeIds,
          curShiftBadQuantity: this.shiftBadQuantity,
          reportDate: this.conditions.reportDate,
          remark: this.remarks,
          reporter: this.yt.editObj.reporter
        };
        this.http
          .post('/web/production/wo/reportByGroupLeader', this.paramsList)
          .then(res => {
            this.$message.success(this.$t(res.msg));
            this.getInfo();
            // this.getTab()
            this.yt.editObj.reporter = '';
            // this.yt.editObj.shiftId=[]
          })
          .catch(error => {
            this.$message.error(this.$t(error));
          });
      } else {
        this.paramsList = {
          shiftId: this.yt.editObj.shiftId,
          curShiftQuantity: this.shiftReportQuantity,
          woProcedureId: this.currentNodeIds,
          curShiftBadQuantity: this.shiftBadQuantity,
          reportDate: this.conditions.reportDate,
          remark: this.remarks
        };
        this.http
          .post('/web/production/wo/report', this.paramsList)
          .then(res => {
            this.$message.success(this.$t(res.msg));
            this.getInfo();
            // this.getTab()
            // this.yt.editObj.shiftId=[]
          })
          .catch(error => {
            this.$message.error(this.$t(error));
          });
      }
    },
    beforeAdd(params, url) {
      params.woProcedureId = params.id;
      params.defectCodeList = [];
      let levelOneDefectTypeId = this.tabs
        .map(item => {
          return item.id;
        })
        .join(',');
      params['levelOneDefectTypeId'] = parseInt(levelOneDefectTypeId);
      if (this.tabs.length > 0) {
        for (let i = 0; i < this.tabs.length; i++) {
          let all = this.tabs[i]['defectCodeVOS'];
          for (let j = 0; j < all.length; j++) {
            let defectCodeId = all[j]['id'];
            let defectDesc = all[j]['desc'];
            let badQuantity = all[j]['badQuantityTmp'];
            let allItem = {
              defectCodeId: defectCodeId,
              defectDesc: defectDesc,
              defectCodeBadQuantity: badQuantity == null || badQuantity == undefined ? 0 : badQuantity
            };
            params.defectCodeList.push(allItem);
          }
        }
      }
      const list = [];
      for (let i = 0; i < this.tabs.length; i++) {
        const item = [];
        for (let j = 0; j < this.tabs[i]['defectCodeVOS'].length; j++) {
          const res = params.defectCodeList.filter(item => {
            return item.defectCodeId === this.tabs[i]['defectCodeVOS'][j].id;
          });
          if (res.length > 0) {
            item.push(res[0]);
          }
        }
        list.push({
          defectCodeVOS: item,
          levelOneDefectTypeId: this.tabs[i]['id']
        });
      }
      params.defectCodeList = list;
      return params;
    },
    countFlow2Heihgt(id) {
      this.flow2Height =
        document
          .getElementById(id)
          .getElementsByClassName('x6-graph-svg-viewport')[0]
          .getBoundingClientRect().height + 120;
      this.flow1Width =
        document
          .getElementById(id)
          .getElementsByClassName('x6-graph-svg-viewport')[0]
          .getBoundingClientRect().width + 120;
      console.log('getBoundingClientRect', this.flow1Width);
    },
    node2Tap(params) {
      // return
      if (this.graph == null) {
        return;
      }
      this.currentNode = params.item;
      this.workProcedureIds = params.item.workProcedureId;
      this.currentNodeIds = params.item.id;
      console.log('jjjjjjjjjjjjjjjj', this.currentNodeIds);
      this.curShiftQuantity = params.item.parentIds;
      this.parentIds = params.item.parentIds;
      this.parentIdItem = params.item['parentIds'];
      if (this.yt.editObj.action == 'baogong') {
        if (this.currentNodeIds) {
          this.getInfo();
        }
        params.item.parentIds == '' || params.item.parentIds == undefined ? this.shiftReportQuantity : 0;
      }
      if (this.yt.editObj.action == 'buliangluru'||this.yt.editObj.action == 'buliangbaogong') {
        if (this.currentNodeIds) {
          // this.getDefectTab({
          //   workProcedureId: this.currentNodeIds
          // })
        }
      }
      const nodes = this.graph.getNodes();
      const nodesIdList = nodes.map(item => {
        return item.data.item.id;
      });

      if (this.currentNodeIds) {
        if (nodesIdList.includes(this.currentNodeIds)) {
          this.procedureName = params.item.procedureCode + '/' + params.item.procedureDesc;
        } else {
          this.procedureName = '';
        }
        console.log('fdvvvvv', nodesIdList.includes(this.currentNodeIds));
        this.handleSetBaoGongLabel(this.currentNodeIds);
      }
      if (nodes.length) {
        nodes.forEach(node2 => {
          node2.setData({
            currentNodeId: this.currentNodeIds
          });
        });
      }
      this.currentNodeId = this.currentNodeIds;
    },
    // 报工-设置默认选中
    handleSetDefBaoGongTab(id) {
      // if (this.yt.editObj.action == 'baogong') {
      for (let i = 0; i < this.tab.length; i++) {
        if (this.tab[i]['woProcedureList']) {
          const woProcedureList = this.tab[i]['woProcedureList'];
          for (let j = 0; j < woProcedureList.length; j++) {
            if (woProcedureList[j]['id'] === id && this.tab[i]['material']) {
              this.topActive = this.tab[i]['material']['name'];
              this.topActive2 = this.tab[i]['material']['name'];
              break;
            }
          }
        }
      }
      // }
    },
    // 报工-设置默认文本
    handleSetBaoGongLabel(id) {
      console.log('handleSetBaoGongLabel', id);
      // if (this.yt.editObj.action === 'baogong') {
      for (let i = 0; i < this.tab.length; i++) {
        if (this.tab[i]['woProcedureList']) {
          const woProcedureList = this.tab[i]['woProcedureList'];
          for (let j = 0; j < woProcedureList.length; j++) {
            if (woProcedureList[j]['id'] === id && this.tab[i]['material']) {
              this.$set(this.tab[i], 'procedureName', this.procedureName);
              console.log('ggggfffff', this.procedureName);
              break;
            }
          }
        }
      }
      // }
    },
    initFlow(id, nodes, edges) {
      this.procedureName = '';
      if (this.yt.editObj.action == 'buliangluru'||this.yt.editObj.action == 'buliangbaogong') {
        this.topActive = this.topActive1;
      }
      if (this.yt.editObj.action == 'baogong') {
        this.topActive = this.topActive;
      }
      if (document.getElementById(id)) {
        document.getElementById(id).innerHTML = '';
      } else {
        return;
      }
      this.graph = new this.x6({
        container: document.getElementById(id),
        // width: 3000,
        // height: 400,
        grid: false,
        interacting: {
          nodeMovable: false
        }
      });

      const model = {
        nodes: nodes,
        edges: edges
      };
      const dagreLayout = new this.x6layout({
        type: 'dagre',
        rankdir: 'TB',
        align: 'DR',
        ranksep: 20,
        nodesep: 20,
        controlPoints: true
      });
      const newModel = dagreLayout.layout(model);
      this.graph.fromJSON(newModel);
      this.countFlow2Heihgt(id);
      // console.log('nodes', nodes)
      this.node2Tap(this.currentItem);
    },
    //获取班次
    getShiftByEquipmentId() {
      this.http
        .get('/web/setting/shift/getShiftByEquipmentId', {
          params: {
            equipmentId: this.equipmentId,
            pageNum: 1,
            pageSize: 1000
          }
        })
        .then(res => {
          this.ShiftByEquipmentList = res.data;
          console.log('vvvvvvvvvvvvvvv', this.obj.id);
          for (let i = 0; i < this.ShiftByEquipmentList.length; i++) {
            if (this.obj.id) {
              this.ShiftByEquipmentList[i]['id'] = this.ShiftByEquipmentList[i]['id'];
              this.yt.editObj.shiftId = this.ShiftByEquipmentList[i]['id'];
            } else {
              if (this.shiftIdListId.id === this.ShiftByEquipmentList[i]['id']) {
                this.ShiftByEquipmentList[i]['id'] = this.shiftIdListId.id;
                this.yt.editObj.shiftId = this.shiftIdListId.id;
              }
            }
          }
        });
    },
    getEquipmentId() {
      this.http
        .get('/web/setting/shift/getCurrentShiftByEquipmentId', {
          params: {
            equipmentId: this.equipmentId,
            pageNum: 1,
            pageSize: 1000
          }
        })
        .then(res => {
          console.log('jjjjjj', res.data);
          this.shiftIdListId = res.data;
          this.$set(this.conditions, 'reportDate', res.data.startTime);
        });
    },
    // 日期转换
    dateFormat(time) {
      const t = new Date(time);
      // 日期格式
      const format = 'Y-m-d h:i:s';
      let year = t.getFullYear();
      // 由于 getMonth 返回值会比正常月份小 1
      let month = t.getMonth() + 1;
      let day = t.getDate();
      let hours = t.getHours();
      let minutes = t.getMinutes();
      let seconds = t.getSeconds();
      month = month > 9 ? month : `0${month}`;
      day = day > 9 ? day : `0${day}`;
      hours = hours > 9 ? hours : `0${hours}`;
      minutes = minutes > 9 ? minutes : `0${minutes}`;
      seconds = seconds > 9 ? seconds : `0${seconds}`;
      const hash = {
        Y: year,
        m: month,
        d: day,
        h: hours,
        i: minutes,
        s: seconds
      };
      return format.replace(/\w/g, o => {
        return hash[o];
      });
    },
    beforeUnqualifiedReport(params, url){
      params.woProcedureId = this.currentNodeIds;
      params.defectCodeList = [];
      params.shiftId = this.shiftIdListId.id;
      let levelOneDefectTypeId = this.tabs
          .map(item => {
            return item.id;
          })
          .join(',');
      params['levelOneDefectTypeId'] = parseInt(levelOneDefectTypeId);
      if (this.tabs.length > 0) {
        let totalBadQuantity = 0;
        for (let i = 0; i < this.tabs.length; i++) {
          let all = this.tabs[i]['defectCodeVOS'];
          for (let j = 0; j < all.length; j++) {
            let defectCodeId = all[j]['id'];
            let defectDesc = all[j]['desc'];
            let badQuantity = all[j]['badQuantityTmp'];
            let allItem = {
              defectCodeId: defectCodeId,
              defectDesc: defectDesc,
              defectCodeBadQuantity: badQuantity == null || badQuantity == undefined ? 0 : badQuantity
            };
            totalBadQuantity += (badQuantity == null || badQuantity == undefined)? 0 : badQuantity;
            params.defectCodeList.push(allItem);
          }
        }
        if(totalBadQuantity == 0){
          this.$message.error(this.$t('wo_bad_quanlity_entry_one'));
          return;
        }else{
          params.curShiftQuantity = totalBadQuantity;
          params.curShiftBadQuantity = totalBadQuantity
        }
      }
      const list = [];
      for (let i = 0; i < this.tabs.length; i++) {
        const item = [];
        for (let j = 0; j < this.tabs[i]['defectCodeVOS'].length; j++) {
          const res = params.defectCodeList.filter(item => {
            return item.defectCodeId === this.tabs[i]['defectCodeVOS'][j].id;
          });
          if (res.length > 0) {
            item.push(res[0]);
          }
        }
        list.push({
          defectCodeVOS: item,
          levelOneDefectTypeId: this.tabs[i]['id']
        });
      }
      params.defectCodeList = list;
      params.type = 0;
      return params;
    },
  }
};
</script>
<style lang="scss" scoped="scoped">
.inputNum /deep/.el-input-number .el-input__inner {
  -webkit-appearance: none;
  //padding-left: 50px;
  //padding-right: 50px;
  /* text-align: center; */
}
.badText /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  // height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 120px;
}
.label-class-blue {
  color: #1989fa;
}

.label-bg-blue {
  background: #1989fa;
  color: #fff;
}

//盒子
.wrap {
  height: 100%;
  width: 100%;
  //border: 1px solid red;
  overflow: hidden;
  display: flex;

  .left {
    margin-bottom: -5000px;
    padding-bottom: 5000px;
    float: left;
    width: 800px;
    //background-color: skyblue;
    //border: 2px solid pink;
  }

  .right {
    flex: 1;
    float: right;
    margin-bottom: -5000px;
    padding-bottom: 5300px;
    //background-color: tan;
    //border: 2px solid pink;
  }
}
</style>
<style scoped>
.org-chart-node-label-inner {
  font-size: 23px !important;
}

/* 设置树宽度 */
.org-chart-container {
  padding: 80px;
  display: flex;
  justify-content: center;
}

.my-selecting {
  color: red !important;
}

.currentTable /deep/ th {
  border: 0 !important;
}

.currentTable:before {
  height: 0 !important;
}

.currentTable /deep/ .el-table__fixed:before {
  height: 0 !important;
}

/* .curd-table /deep/ .el-table__fixed:before {
  height: 0 !important;
} */
.currentTable /deep/ .el-table__body .el-table__row td {
  border: 0 !important;
}

.currentTable /deep/ .el-table--border td,
.el-table--border th {
  /* border-right: 1px solid #ebeef5; */
}
</style>
